import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  transform(str: string, search): string {
    if (search && typeof search !== 'object' && str) {
      let pattern = search.replace(
        /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
        '\\$&'
      );
      pattern = pattern
        .split(' ')
        .filter((t) => {
          return t.length > 0;
        })
        .join('|');
      const regex = new RegExp(pattern, 'gi');

      return str.replace(
        regex,
        (strmatch) => `<span class="search-highligh-text">${strmatch}</span>`
      );
    } else {
      return str;
    }
  }
}
